<template>
  <div>
    <form id="login-form" role="form" style="display: block;" class="white_bg p-4" @submit.prevent="onSubmit">
      <div class="row m-0 form_holder p-0">
        <div class="col-12 mb-3 p-0 pb-3 border-bottom">
          <div class="row m-0 align-items-center">
            <div class="col p-0">
              <h4 class="mb-0">Login</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0 form_holder p-0">
        <div class="col-12 p-0">
          <div class="form-group">
            <label for="name">Email Address</label>
            <input
              type="email"
              name="email"
              id="email"
              class="form-control"
              placeholder="Email Address"
              autocomplete=""
              v-model="email"
              maxlength="35"
              required
            />
          </div>
          <div class="form-group">
            <label for="name">Password</label>
            <input
              type="password"
              name="password"
              id="password"
              autocomplete=""
              class="form-control"
              placeholder="Password"
              v-model="password"
              required
            />
          </div>
          <div class="form-group my-4">
            <button type="submit" class="btn btn-primary w-100" disabled v-if="isLoading">
              Logging in...
              <div class="spinner-border spinner-border-sm" role="status" >
                <span class="visually-hidden">Loading...</span>
              </div>
            </button>
            <button type="submit" class="btn btn-primary w-100" v-else>
              Log in
            </button>
          </div>
          <div class="border-bottom mb-4"></div>
          <div class="error_text text-center mb-3" v-if="hasError">{{errorMsg}}</div>
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <div class="text-center smaller_font">
                  Forgot password? <span class="link_colour cursor" @click="goTo('forgot')">Click here</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-lg-12">
                <div class="text-center smaller_font">
                  Don't have an account? <span class="link_colour cursor" @click="goToRegister">Register</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <TwoStepOTP v-if="isOTP" @close="cancelOTP" :mobile="this.loginPhone" @verified="login" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TwoStepOTP from './TwoStepOTP.vue'
export default {
  components: { TwoStepOTP },
  data () {
    return {
      email: '',
      password: '',
      hasError: false,
      errorMsg: '',
      isOTP: false,
      mobile: null,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['is2FAenabled', 'is2FAverified', 'loginEmail', 'loginPassword', 'loginPhone'])
  },
  methods: {
    ...mapActions(['loginWithEmail', 'sendTheOTP', 'logout', 'check2FA']),
    async onSubmit () {
      this.isLoading = true
      const data = {
        email: this.email,
        password: this.password
      }
      await this.check2FA(data)
      this.loginWithEmail(data).then(async () => {
        if (this.is2FAenabled) {
          this.isOTP = true
          await this.logout()
          await this.sendTheOTP(this.loginPhone)
        }
      }).catch((error) => {
        if (error) {
          this.hasError = true
          this.errorMsg = 'Email or password is not recognized. Please try again.'
          this.isLoading = false
        }
      })
    },
    cancelOTP () {
      this.isLoading = false
      this.isOTP = false
    },
    login () {
      this.isLoading = true
      const data = {
        email: this.loginEmail,
        password: this.loginPassword
      }
      this.loginWithEmail(data).then(() => {
        this.isLoading = false
      }).catch((error) => {
        if (error) {
          this.hasError = true
          this.errorMsg = 'Email or password is not recognized. Please try again.'
          this.isLoading = false
        }
      })
    },
    goTo (val) {
      this.$emit('goTo', val)
    },
    goToRegister () {
      this.$router.push('/register')
    }
  }
}
</script>
<style scoped>
label {
  margin-bottom: 0;
}
</style>
